import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { EntrepotTypeDto } from '@lexi-clients/lexi';
import { EntrepotTypeListResult } from '../models/entrepot-type-list';

@Injectable({
  providedIn: 'root'
})
export class EntrepotTypeListService implements IGridService<EntrepotTypeDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<EntrepotTypeListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/EntrepotTypes/rechercher`, { params: params });
  }

  getById(entrepotTypeId: number): Observable<EntrepotTypeDto> {
    return this.http.get<any>(`${this.baseUrl}/api/EntrepotTypes/${entrepotTypeId}`);
  }

  post(valeur: EntrepotTypeDto): Observable<any> {
    return null;
  }

  put(valeur: EntrepotTypeDto): Observable<any> {
    return null;
  }

  delete(valeur: EntrepotTypeDto): Observable<any> {
    return null;
  }
}
